module.exports = __webpack_public_path__ + "static/af-008dc3229529b5e6be2aa03ce93fc03e.svg";